export var valuesWikiMediaOverlayType = ["HotSpotTooltip", "HotSpotOpen"];
/*

*/ 
//# sourceMappingURL=WikiMediaOverlayType.js.map